module.exports = __webpack_public_path__ + "static/media/award-1.ba1b023f.png";